// These theme values should be the same as what is in `views/theme.scss`

export const DEFAULT_THEME = 'default';
export const DARK_THEME = 'dark';
